import {observer} from "mobx-react-lite"
import React, {useEffect} from "react"
// import priceUpdateController from "../../store/pageControllers/PriceUpdateController"
import CliApi from "../../api/CliApi"
import {TaskControls} from "../../components/task_buttons/TaskControls";
import {Link} from "react-router-dom"
import {appPages} from "../../App";
import {Field, Fields, FieldsGroup, Select} from "../../lib/wa-2.0"
import {SelectProductsCategoriesOrSets} from "../../components/SelectProductsCategoriesOrSets"
import controller from "../../store/pageControllers/PriceSettingsController"
import priceUpdateController from "../../store/pageControllers/PriceUpdateController"
import ImageSettingsRules from "../../store/entities/rules/ImageSettingsRules"
import {RuleComponent} from "../../components/rule/RuleComponent"

export const PriceUpdateSettings = observer(() => {
    useEffect(() => {
        controller.loadSettings()
        priceUpdateController.loadSettings()
    }, [])

    return <div className={"custom-mt-32"} id={'price_markup'}>
        {/*<h6>{"Обновление цен".toUpperCase()}</h6>*/}
        <Fields>
            <FieldsGroup>
                <SelectProductsCategoriesOrSets
                    {...controller.productCollectionSettings}
                    addFromExportVariant={true}
                    changeState={state => {
                        controller.productCollectionSettings = state
                        setTimeout(()=>{priceUpdateController.loadSettings()}, 200)
                    }}
                />
                <Field label={"Сопоставить товары по:"}>
                    <Select
                        className={"width-40"}
                        options={controller.productSyncByOptions}
                        value={controller.valueOfProductFindBy.value}
                        onChange={(e) => controller.productSyncBy = e.target.value}
                    />
                </Field>
                <Field label={"Хранить историю обновления остатков:"}>
                    <Select
                        className={"width-40"}
                        options={controller.historyOptions}
                        value={controller.historyDaysKeep}
                        onChange={(e) => controller.historyDaysKeep = Number(e.target.value)}
                    />
                </Field>
                {controller.prices.map((rule, index) => {
                    return <RuleComponent
                        key={index + rule.type}
                        rule={rule}
                        onMouseEnterInput={() => {
                            rule.callInputLoadExampleValue()
                        }}
                    />
                })}

            </FieldsGroup>
        </Fields>
        <br/>
        <div className={"custom-mb-4"}>Наценка по категориям товаров</div>
        <div className={"prices-table"}>
            <div className={"flexbox full-width"} style={{backgroundColor: "#F3f3f3"}}>
                <div className={"custom-px-16 custom-py-20 width-40 wide"}>
                    Категория
                </div>
                <div className={"custom-px-16 custom-py-20"} style={{boxSizing: "border-box", width: "20%"}}>
                    Цена
                </div>
                <div className={"custom-px-16 custom-py-20"} style={{boxSizing: "border-box", width: "20%"}}>
                    Цена без скидки
                </div>
                <div className={"custom-px-16 custom-py-20"} style={{boxSizing: "border-box", width: "20%"}}>
                    Цена Premium
                </div>
            </div>
            {priceUpdateController
                .markUps?.map(
                    (val, index) => <div key={'markUps' + index}>{val.components}</div>)}
        </div>
    </div>
})